import React from 'react';
import useScrollFix from '@hooks/common/useScrollFix';

export type PageModalProps = {
  children: React.ReactElement;
  closeButtonTheme?: 'dark';
  needCloseButton?: boolean;
  onClose: () => void;
  onClickClose?: () => void;
};

export default function PageModal({
  children,
  onClickClose,
  onClose,
}: PageModalProps) {
  useScrollFix();

  return (
    <div className="w-full h-[100vh] overflow-hidden fixed top-0 left-0 z-30 surface_primary">
      {React.cloneElement(children, { onClickClose, onClose })}
    </div>
  );
}
